import { Button, Modal, Image, Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import Link from 'next/link'

const NotifyPopup = ({
	children,
	isVisible,
	srcImage,
	message,
	handleCancel,
	zIndex,
	description,
	closable,
	title,
	setIsVisiblePopup,
}) => {
	useEffect(() => {
		if (isVisible && setIsVisiblePopup)
			setTimeout(() => {
				setIsVisiblePopup(false)
			}, 2500)
	}, [isVisible])
	return (
		<div className="noti_popup">
			<Modal
				className="noti-modal"
				style={{ textAlign: 'center', borderRadius: 12 }}
				footer={null}
				title={title ? title : 'Thông báo'}
				open={isVisible}
				onCancel={handleCancel}
				centered
				zIndex={zIndex === 0 ? 1000 : zIndex}
				closable={closable ? true : closable}
				maskClosable={false}
			>
				<div className="noti-popup-content">
					{!!srcImage && <Image preview={false} src={srcImage} alt="noti-image" />}
					<span style={{ marginTop: 16 }}>{message}</span>
					{!!description && (
						<span style={{ marginTop: 16, color: '#5E6278', fontSize: 14, fontWeight: 500 }}>
							{description}
						</span>
					)}
					{!!children && children}
				</div>
			</Modal>
		</div>
	)
}

export default NotifyPopup
